/*
 * Mengenrabatt nur für gleiche Sorten (Bschüssig, 07.10.2026).
 * Ab 3 gleichen Einzelstücken einer Sorte → Variante «3 Beutel» (−5 %), ab 6 → «6 Beutel» (−10 %).
 * Läuft nach jedem Warenkorb-Request des Themes (add/change/update) und rechnet pro Sorte neu:
 * Gesamtmenge = Einzelstücke + 3 × 3er + 6 × 6er → so viele 6er wie möglich, dann 3er, Rest einzeln.
 * Abo-Positionen und Positionen mit sichtbaren Eigenschaften bleiben unangetastet.
 * Black Month 2026: im Zeitfenster (window.BSG_BFCM.on, snippets/bsg-bfcm-head.liquid) zuerst 12er-Packs (−20 % über den
 * terminierten automatischen Rabatt). Ausserhalb werden vorhandene 12er wieder in 6er aufgeteilt.
 */
const mapEl = document.getElementById('bsg-pack-map');
const MAP = mapEl ? JSON.parse(mapEl.textContent || '{}').units || {} : {};
const PACKS = {};
for (const [unit, p] of Object.entries(MAP)) {
  if (p['3']) PACKS[p['3']] = { unit, size: 3 };
  if (p['6']) PACKS[p['6']] = { unit, size: 6 };
  if (p['12']) PACKS[p['12']] = { unit, size: 12 };
}
const bfcmOn = () => Boolean(window.BSG_BFCM && window.BSG_BFCM.on);
const origFetch = window.fetch.bind(window);
let busy = false;
let timer = null;

const isCartMutation = (input) => {
  try {
    const url = new URL(typeof input === 'string' ? input : input.url, location.origin);
    return /\/cart\/(add|change|update)(\.js)?$/.test(url.pathname);
  } catch { return false; }
};

if (Object.keys(MAP).length) {
  window.fetch = async (input, init) => {
    const response = await origFetch(input, init);
    if (!busy && response.ok && isCartMutation(input)) schedule();
    return response;
  };
  if (/\/cart\/?$/.test(location.pathname)) schedule(0);
  // Black Month: beim Seitenaufruf im Zeitfenster vorhandene 6er zu 12ern zusammenfassen und danach (bis 31 Tage
  // nach Ende) 12er wieder aufteilen, auch wenn der Warenkorb seit dem Wechsel nicht geändert wurde.
  else if (window.BSG_BFCM && Date.now() >= window.BSG_BFCM.start && Date.now() <= window.BSG_BFCM.end + 31 * 864e5) schedule(800);
}

function schedule(delay = 350) {
  clearTimeout(timer);
  timer = setTimeout(() => normalize().catch(() => {}), delay);
}

const postJson = (url, body) =>
  origFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
    .then((r) => r.json());

async function normalize() {
  if (busy) return;
  busy = true;
  try {
    const cart = await origFetch('/cart.js').then((r) => r.json());
    const groups = {};
    for (const item of cart.items) {
      if (item.selling_plan_allocation) continue;
      const props = item.properties || {};
      if (Object.keys(props).some((k) => !k.startsWith('_') && props[k])) continue;
      const vid = String(item.variant_id);
      let unit; let size;
      if (MAP[vid]) { unit = vid; size = 1; } else if (PACKS[vid]) { ({ unit, size } = PACKS[vid]); } else continue;
      (groups[unit] ||= { total: 0, lines: [] });
      groups[unit].total += item.quantity * size;
      groups[unit].lines.push({ key: item.key, qty: item.quantity, size });
    }
    const updates = {};
    const adds = [];
    for (const [unit, group] of Object.entries(groups)) {
      const packs = MAP[unit];
      let rest = group.total;
      const want = { 12: 0, 6: 0, 3: 0, 1: 0 };
      if (packs['12'] && bfcmOn()) { want[12] = Math.floor(rest / 12); rest -= want[12] * 12; }
      if (packs['6']) { want[6] = Math.floor(rest / 6); rest -= want[6] * 6; }
      if (packs['3']) { want[3] = Math.floor(rest / 3); rest -= want[3] * 3; }
      want[1] = rest;
      const seen = {};
      for (const line of group.lines) {
        const target = seen[line.size] ? 0 : want[line.size];
        seen[line.size] = true;
        if (line.qty !== target) updates[line.key] = target;
      }
      for (const size of [12, 6, 3, 1]) {
        if (!seen[size] && want[size] > 0) adds.push({ id: Number(size === 1 ? unit : packs[String(size)]), quantity: want[size] });
      }
    }
    if (!Object.keys(updates).length && !adds.length) return false;
    if (Object.keys(updates).length) await postJson('/cart/update.js', { updates });
    if (adds.length) await postJson('/cart/add.js', { items: adds });
    await refreshUi();
    return true;
  } finally {
    busy = false;
  }
}

// Für Black-Month-Buttons im Warenkorb («+2 hinzufügen»): nach dem Hinzufügen normalisieren und Anzeige auffrischen.
window.BSG_packNormalize = async () => { if (!(await normalize().catch(() => false))) await refreshUi(); };

async function refreshUi() {
  const cart = await origFetch('/cart.js').then((r) => r.json());
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  try {
    const sections = sectionIds.length
      ? await origFetch(`${location.pathname}?sections=${encodeURIComponent(sectionIds.join(','))}`).then((r) => r.json())
      : {};
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: deferred.promise }));
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'bsg-pack-normalizer', sourceId: 'bsg-pack-normalizer', itemCount: cart.item_count, sections, didError: false },
    });
  } catch (error) {
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }
}
